/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { colors } from '../../utils/colors';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const ContainerLogin = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
`;

export const WrapLogin = styled.div`
  width: 100%;
`;

export const LoginFormTitle = styled.span`
  display: block;
  font-size: 30px;
  line-height: 1.2;
  text-align: center;
`;

export const LoginInput = styled.div`
  width: 100%;
  position: relative;
`;

export const LoginForm = styled.form`
  border-bottom: 10px solid #136033;
  max-width: 536px;
  width: 100%;
  min-width: 320px;
  padding: 79px 68px;
  box-shadow: 0 10px 10px rgb(209, 209, 209);
  border-radius: 10px;
  margin: 0 auto;
`;

export const InputLogin = styled.input`
  width: 100%;
  margin: 16px 0;
  height: 40px;
  border-radius: 8px;
  background-color: #f6f6f6;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  color: green;

  &:focus {
    outline: none;
    border: 1px solid green;
  }
`;

export const ContainerLoginFormBtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
`;

export const LoginBtn = styled.button`
  color: #f6f6f6;
  background-color: #136033;
  border: 1px solid #136033;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: ease-in-out 0.5s;

  &:hover {
    background: #fff;
    color: #136033;
    transition: ease-in-out 0.5s;
  }
`;

export const PassIcon = styled.span`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.cinza30};
`;
